import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SessionService } from '../services/session.service';

export const availableGuard = () => {
	const sessionService: SessionService = inject(SessionService);
	const router: Router = inject(Router);

	return sessionService.hasExpired$
		.asObservable()
		.pipe(
			map((value: boolean) => {
				if (!value) return true;

				return new RedirectCommand(
					router.createUrlTree(sessionService.getLink(['expired'])),
					{ replaceUrl: true, skipLocationChange: false }
				);
			})
		);
}
